type OnboardingStep = {
  title: string;
  body: string;
  highlights: string[];
};

type OnboardingModalProps = {
  steps: OnboardingStep[];
  stepIndex: number;
  labels: {
    welcome: string;
    skip: string;
    step: string;
    back: string;
    next: string;
    start: string;
  };
  onChangeStep: (index: number) => void;
  onSkip: () => void;
  onComplete: () => void;
};

export function OnboardingModal({ steps, stepIndex, labels, onChangeStep, onSkip, onComplete }: OnboardingModalProps) {
  const isLastStep = stepIndex >= steps.length - 1;
  const step = steps[stepIndex];

  return (
    <div className="sheet-overlay" onClick={() => undefined}>
      <div className="sheet onboarding-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-header">
          <h3>{labels.welcome}</h3>
          <button onClick={onSkip}>{labels.skip}</button>
        </div>
        <div className="small onboarding-step">
          {labels.step}
        </div>
        <div className="card onboarding-card">
          <div className="row-title">{step.title}</div>
          <div>{highlightBody(step.body, step.highlights)}</div>
        </div>
        <div className="dots onboarding-dots">
          {steps.map((_, i) => (
            <span key={i} className={i === stepIndex ? 'dot active' : 'dot'} />
          ))}
        </div>
        <div className="timer-buttons onboarding-actions">
          <button disabled={stepIndex === 0} onClick={() => onChangeStep(Math.max(0, stepIndex - 1))}>
            {labels.back}
          </button>
          {isLastStep ? (
            <button onClick={onComplete}>{labels.start}</button>
          ) : (
            <button onClick={() => onChangeStep(Math.min(steps.length - 1, stepIndex + 1))}>{labels.next}</button>
          )}
        </div>
      </div>
    </div>
  );
}

function highlightBody(body: string, terms: string[]): Array<string | JSX.Element> {
  const cleanTerms = terms
    .map((term) => term.trim())
    .filter((term, index, arr) => term.length > 0 && arr.indexOf(term) === index)
    .sort((a, b) => b.length - a.length);
  if (cleanTerms.length === 0) return [body];
  const pattern = new RegExp(`(${cleanTerms.map(escapeRegExp).join('|')})`, 'g');
  const parts = body.split(pattern);
  return parts.map((part, index) => {
    if (cleanTerms.includes(part)) {
      return (
        <span key={`onboarding-hl-${index}`} className="onboarding-keyword">
          {part}
        </span>
      );
    }
    return part;
  });
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
